import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerClientContactProfile from "../../controller/custom/ClientContactProfile";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPageClientContactProfile: React.FC = () => {
    // Variable
    const controllerClientContactProfile = new ControllerClientContactProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerClientContactProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerClientContactProfile.getSelectOption && controllerClientContactProfile.getValidationForm) {
        return (
            <div className="view_client_contact_profile form" data-at_id="view_client_contact_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerClientContactProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="id"
                                                        label={controllerLocalization.getStorageMain.id}
                                                        defaultValue={controllerClientContactProfile.getDataMain.id || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value date"
                                                        data-at_id="input_latest_update"
                                                        name="latest_update"
                                                        label={controllerLocalization.getStorageMain.latest_update}
                                                        value={
                                                            controllerClientContactProfile.getDataMain.latest_update
                                                                ? HelperSrc.localeFormat(
                                                                      new Date(controllerClientContactProfile.getDataMain.latest_update)
                                                                  )
                                                                : ""
                                                        }
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_latest_update_by_id"
                                                        name="latest_update_by_id"
                                                        label={controllerLocalization.getStorageMain.latest_update_by}
                                                        defaultValue={(() => {
                                                            for (const optionData of Object.values(
                                                                controllerClientContactProfile.getSelectOption.latest_update_by_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (
                                                                    controllerClientContactProfile.getDataMain.latest_update_by_id ===
                                                                    optionDataTyped.value
                                                                ) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );

                                        return html;
                                    })()}
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerClientContactProfile.getSelectOption.client_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerClientContactProfile.getElementClientIdValue === "" &&
                                                    controllerClientContactProfile.getDataMain
                                                        ? controllerClientContactProfile.getDataMain.client_id
                                                        : controllerClientContactProfile.getElementClientIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(
                                                        controllerClientContactProfile.getSelectOption.client_id
                                                    )) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_client_id"
                                                        required={
                                                            controllerClientContactProfile.getValidationForm
                                                                ? controllerClientContactProfile.getValidationForm.client_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => {
                                                            HelperSrc.checkRegexSelect(event.target.name, event.target.value);
                                                        }}
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.client : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="client_id"
                                                        defaultValue={
                                                            controllerClientContactProfile.getElementClientIdValue === "" &&
                                                            controllerClientContactProfile.getDataMain
                                                                ? controllerClientContactProfile.getDataMain.client_id !== undefined
                                                                    ? controllerClientContactProfile.getDataMain.client_id
                                                                    : ""
                                                                : controllerClientContactProfile.getElementClientIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerClientContactProfile.setElementClientIdValue) {
                                                    controllerClientContactProfile.setElementClientIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_department"
                                            name="department"
                                            label={controllerLocalization.getStorageMain.department}
                                            defaultValue={controllerClientContactProfile.getDataMain.department || ""}
                                            required={controllerClientContactProfile.getValidationForm.department.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.department.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.department.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_first_name"
                                            name="first_name"
                                            label={controllerLocalization.getStorageMain.first_name}
                                            defaultValue={controllerClientContactProfile.getDataMain.first_name || ""}
                                            required={controllerClientContactProfile.getValidationForm.first_name.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.first_name.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.first_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_last_name"
                                            name="last_name"
                                            label={controllerLocalization.getStorageMain.last_name}
                                            defaultValue={controllerClientContactProfile.getDataMain.last_name || ""}
                                            required={controllerClientContactProfile.getValidationForm.last_name.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.last_name.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.last_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_first_name_kanji"
                                            name="first_name_kanji"
                                            label={controllerLocalization.getStorageMain.first_name_kanji}
                                            defaultValue={controllerClientContactProfile.getDataMain.first_name_kanji || ""}
                                            required={controllerClientContactProfile.getValidationForm.first_name_kanji.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.first_name_kanji.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.first_name_kanji.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_last_name_kanji"
                                            name="last_name_kanji"
                                            label={controllerLocalization.getStorageMain.last_name_kanji}
                                            defaultValue={controllerClientContactProfile.getDataMain.last_name_kanji || ""}
                                            required={controllerClientContactProfile.getValidationForm.last_name_kanji.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.last_name_kanji.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.last_name_kanji.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_first_name_kana"
                                            name="first_name_kana"
                                            label={controllerLocalization.getStorageMain.first_name_kana}
                                            defaultValue={controllerClientContactProfile.getDataMain.first_name_kana || ""}
                                            required={controllerClientContactProfile.getValidationForm.first_name_kana.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.first_name_kana.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.first_name_kana.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_last_name_kana"
                                            name="last_name_kana"
                                            label={controllerLocalization.getStorageMain.last_name_kana}
                                            defaultValue={controllerClientContactProfile.getDataMain.last_name_kana || ""}
                                            required={controllerClientContactProfile.getValidationForm.last_name_kana.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.last_name_kana.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.last_name_kana.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_phone_number"
                                            name="phone_number"
                                            label={controllerLocalization.getStorageMain.phone_number}
                                            defaultValue={controllerClientContactProfile.getDataMain.phone_number || ""}
                                            required={controllerClientContactProfile.getValidationForm.phone_number.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.phone_number.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.phone_number.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_email"
                                            name="email"
                                            label={controllerLocalization.getStorageMain.email}
                                            defaultValue={controllerClientContactProfile.getDataMain.email || ""}
                                            required={controllerClientContactProfile.getValidationForm.email.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.email.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.email.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.is_reviewer}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_reviewer"
                                            name="is_reviewer"
                                            defaultChecked={controllerClientContactProfile.getDataMain.is_reviewer || false}
                                            required={controllerClientContactProfile.getValidationForm.is_reviewer.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.is_reviewer.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.is_reviewer.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.is_active}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_active"
                                            name="is_active"
                                            defaultChecked={controllerClientContactProfile.getDataMain.is_active || false}
                                            required={controllerClientContactProfile.getValidationForm.is_active.required}
                                            onChange={(event) => {
                                                if (controllerClientContactProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientContactProfile.getValidationForm.is_active.regex_pattern,
                                                        controllerClientContactProfile.getValidationForm.is_active.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerClientContactProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerClientContactProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerClientContactProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageClientContactProfile;
